import { Select, SelectProps } from 'antd'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

type Props = {
  countryCode?: string
} & SelectProps<boolean, { label: string; value: boolean }>

export const ResidentSelect = ({ countryCode, onChange, ...props }: Props) => {
  const { t } = useTranslation()

  const options = [
    { value: true, label: t('resident') },
    { value: false, label: t('non_resident') }
  ]

  useEffect(() => {
    if (countryCode !== 'MD') return

    onChange?.(true)
  }, [countryCode])

  return (
    <Select
      placeholder={t('status')}
      options={options}
      onChange={onChange}
      {...props}
    />
  )
}
